import { Component, OnInit, Input, Optional, ComponentFactoryResolver, ViewContainerRef, TemplateRef, ViewChild, SimpleChange, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { AbstractControl, FormGroupDirective, FormsModule } from '@angular/forms';
import { map, switchMap, filter, takeUntil } from 'rxjs/operators';
import { of, merge, Observable, BehaviorSubject, combineLatest, forkJoin, Subject } from 'rxjs';
import { MmTranslateService } from '../../i18n/translate.service';

import { mmFormConstants } from '../form-constants';
import { NzFormControlComponent } from 'ng-zorro-antd/form';
import { formatStr } from '../../common';

@Component({
  selector: 'mm-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MmFormErrorComponent implements OnInit, OnDestroy {

  // nzFormControl: NzFormControlComponent;
  constructor(
    private translateService: MmTranslateService,
    @Optional() private formGroup: FormGroupDirective,
    private resover: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    private cdf: ChangeDetectorRef,
    @Optional() public nzFormControl: NzFormControlComponent) {
    // this.nzFormControl = nzFormControl;


  }

  onDestroy$ = new Subject();
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }



  asTemplate: boolean = false;
  message$: Observable<string>;

  // @Input()
  // nzFormControl: NzFormControlComponent;
  @ViewChild(TemplateRef)
  template: TemplateRef<any>
  ngOnInit(): void {

    if (!this.formGroup) return;
    const root = this.formGroup.control.root;
    const group = this.formGroup.control;
    this.message$ = combineLatest([this.name$, this.type$, this.labelName$]).pipe(
      takeUntil(this.onDestroy$),
      map(([name, type, labelName]) => { return { name, type, labelName } }),
      switchMap(ctx => merge(
        of(undefined),
        root.valueChanges,
        root.statusChanges
      ).pipe(map(() => ctx))),
      switchMap(ctx => {
        const control = this.nzFormControl.validateControl;
        if (!control) return of(undefined);
        if (control.valid) return of(undefined);
        var errors = control.errors;
        for (const e in errors) {

          switch (e) {
            case "required": {
              return this.requiredMessage(errors[e], ctx.labelName || ctx.name);
            }
            case "requiredLang": {
              return this.requiredLangMessage(errors[e].lang, ctx.labelName || ctx.name)
            }
            case "minlength": {
              return this.minlengthMessage(errors[e], ctx.labelName || ctx.name);
            }
            default: {
              const message = errors[e].message;
              if (typeof message === "string") {
                return of(message);
              }
              else if (message instanceof Observable) {
                return message;
              }

            }
          }

        }
        return of(undefined);
      })
    )


    if (this.nzFormControl) {
      this.message$.pipe(filter(_ => _ !== undefined)).subscribe(message => {




        const nzErrorTip = this.nzFormControl.nzErrorTip;
        if (nzErrorTip === message) return;
        const status = this.nzFormControl.status;
        // if (this.nzFormControl.validateControl.invalid && !message) return;
        // if (this.nzFormControl.validateControl.valid && message) return;
        // const validateControl = this.fc.validateControl;
        this.nzFormControl.nzErrorTip = message;
        this.nzFormControl.status = "error";

        // this.fc.validateControl = info.control;



        this.nzFormControl.ngOnChanges({
          nzErrorTip: new SimpleChange(nzErrorTip, this.nzFormControl.nzErrorTip, true),
          status: new SimpleChange(status, this.nzFormControl.status, true)
        });

        (this.nzFormControl.validateControl as AbstractControl).updateValueAndValidity();

      })

      return;
    }
  }



  name$ = new BehaviorSubject<string>(undefined);
  @Input()
  set name(_: string) {
    this.name$.next(_);
  }



  type$ = new BehaviorSubject<string>(undefined);
  @Input()
  set type(_: string) {
    this.type$.next(_);
  }

  labelName$ = new BehaviorSubject<string>(undefined);
  @Input()
  set labelName(_: string) {
    this.labelName$.next(_);

  }

  resovleKey(key: string) {
    return `${mmFormConstants.translationGroup}.${key}`

  }

  requiredMessage(val: any, labelName: string) {
    return this.translateService.get(this.resovleKey("Required")).pipe(
      map(str => {

        return formatStr(str, labelName)
      })
    )
  }


  requiredLangMessage(lang: string, labelName: string) {
    return forkJoin([
      this.translateService.get(this.resovleKey("Required1")),
      this.translateService.get(this.resovleKey(lang))]
    ).pipe(
      map(([str, lang]) => {
        // debugger;
        return formatStr(str, lang, labelName);
      })
    )
  }




  minlengthMessage(err: any, labelName: string) {
    if (typeof err !== "object") {
      err = {}
    }


    if (err.minlength === undefined && !err.lang) {
      return this.translateService.get(this.resovleKey("Minlength")).pipe(
        map(str => {
          return formatStr(str, labelName)
        })
      )
    }
    else if (err.minlength === undefined && err.lang) {
      forkJoin([this.translateService.get("Minlength1"), this.translateService.get(this.resovleKey(err.lang))]).pipe(
        map(([str, lang]) => {
          return formatStr(str, lang, labelName, err.length)
        })
      )
    }
    else if (err.minlength !== undefined && !err.lang) {
      return this.translateService.get(this.resovleKey("Minlength2")).pipe(
        map(str => {
          return formatStr(str, labelName, err.minlength)
        })
      )

    }
    else {
      return forkJoin([this.translateService.get(this.resovleKey("Minlength3")), this.translateService.get(this.resovleKey(err.lang))]).pipe(
        map(([str, lang]) => {
          return formatStr(str, lang, labelName, err.minlength)
        })
      )
    }

  }



}

interface ErrorInfo {
  type: string;
  control: AbstractControl;
  message: string
}
